import {NgModule} from '@angular/core';
import {FunctieRoosterComponent} from './rooster/functie-rooster.component';
import {MaterialModule} from '../../app.material.module';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {VirtualScrollerModule} from '@iharbeck/ngx-virtual-scroller';
import {FunctieSelectorComponent} from './selector/functie-selector.component';
import {SearchModule} from '../search/search.module';
import {RadarChartModule} from '../radar-chart/radar-chart.module';
import {FunctieModalComponent} from './modal/functie-modal.component';
import {ContentModule} from '../../services/content/content.module';
import {LaneModule} from '../lane/lane.module';
import {FunctieCardModule} from './card/functie-card.module';
import {ShareModule} from '../share/share.module';
import {FunctieDetailComponent} from './detail/functie-detail.component';
import {AccordionModule} from '../accordion/accordion.module';
import {CompetenceListModule} from '../competence-list/competence-list.module';
import {InterestSelectorModule} from '../interest/interest-selector/interest-selector.module';
import {FormsModule} from '@angular/forms';
import {PortalModule} from '@angular/cdk/portal';
import {FilterModule} from '../filter/filter.module';

@NgModule({
    declarations: [FunctieRoosterComponent, FunctieSelectorComponent, FunctieDetailComponent, FunctieModalComponent],
    imports: [
        MaterialModule,
        CommonModule,
        RouterModule,
        VirtualScrollerModule,
        SearchModule,
        RadarChartModule,
        ContentModule,
        FunctieCardModule,
        LaneModule,
        ShareModule,
        AccordionModule,
        CompetenceListModule,
        InterestSelectorModule,
        FormsModule,
        FilterModule,
        PortalModule
    ],
    exports: [FunctieRoosterComponent, FunctieSelectorComponent, FunctieDetailComponent, FunctieModalComponent]
})
export class FunctieModule {}
